// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"519":"69ca8bdf","781":"642ce5ab"}[chunkId] + ".chunk.css";
};